import React from 'react'

import { LabelsTable } from 'modules/Labels/components'
import { useZonesList } from 'modulesCommon/serviceHooks'

import { useLoading, useServerError } from 'shared/hooks'

import { NoItems } from 'components'

const LabelsListContainer = () => {
  const { zoneList, zoneError, zoneLoading } = useZonesList()

  useServerError([zoneError])
  useLoading({ isLoading: zoneLoading })

  return (
    <>
      {!zoneList.length && <NoItems name="labels" />}
      {zoneList.length ? <LabelsTable labelsList={zoneList} /> : null}
    </>
  )
}

export default LabelsListContainer
